import keyMirror from 'keymirror';

export default keyMirror({
  GlobalElementSetFormModal: null,
  MigrateGloablElementSetCategoriesToLabelsModal: null,
  CreateLabelModal: null,
  CreatePDFPresetModal: null,
  InsertGlobalElementsModal: null,
  NewGlobalElementModal: null,
  GlobalElementsActivationModal: null,
  TeleprompterActivationModal: null,
  TeleprompterWelcomeModal: null,
  PublishGEChanges: null,
  PublishGESuccess: null,
  KeyboardShortcuts: null,
  ViewingDeletedEventError: null,
  UpgradeAlert: null,
  EventForm: null,
  EventDocForm: null,
  EventDocUploadStatusPane: null,
  EventDuplicateForm: null,
  EventFolderForm: null,
  EventMoveObjectForm: null,
  EventTrashRestoreForm: null,
  ShowTemplateForm: null,
  CopyShowToTargetEvent: null,
  CopyShowToTargetEventSuccess: null,
  RestoreEventSuccess: null,
  TeamForm: null,
  CardForm: null,
  ShowForm: null,
  CreateForm: null,
  ExportForm: null,
  ExportPDFV3Form: null,
  WordExportForm: null,
  CreateTeamPrompt: null,
  EventList: null,
  EventShowList: null,
  Onboarding: null,
  CellAsset: null,
  CellLink: null,
  GuestPass: null,
  RemoteTeleprompter: null,
  RemoteTeleprompterModal: null,
  GlobalElementsGuestPass: null,
  Cuesheet: null,
  CuesheetItemNumber: null,
  CuesheetItemTitle: null,
  CuesheetItemDescription: null,
  CuesheetItemMenu: null,
  CuesheetItemDuration: null,
  CuesheetItemStartTime: null,
  CuesheetItemPresetDuration: null,
  CuesheetItemCell: null,
  CuesheetItemNote: null,
  CuesheetColumnConfigMenu: null,
  CuesheetStartTimeArrows: null,
  CuesheetPresetDurationArrows: null,
  DisplayViewModal: null,
  RemotePrompterOnboardingModal: null,
});
